export const getCurrentDateInSelectedLocale = (
	timeZone = "America/New_York",
	dateStyle = "ISO",
	locale = "en-us",
	dateFormat = ""
) => {
	const currentDate = new Date();
	const options = { timeZone };
	const isISO = dateStyle === "ISO";
	if (isISO) {
		locale = "en-us";
	} else {
		locale = locale.replace("_", "-").toLowerCase();
		options.dateStyle = dateStyle; // full
		options.calendar = "gregory";
	}

	try {
		const validLocales = Intl.DateTimeFormat.supportedLocalesOf(
			[locale, locale.split("-")[0], "en"],
			{ localeMatcher: "lookup" }
		);
		const validLocale = validLocales[0];
		const formatter = new Intl.DateTimeFormat(validLocale, options);
		let date = formatter.format(currentDate);
		if (isISO) {
			const [month, day, year] = date.split("/");
			return `${year}-${month}-${day}`;
		} else {
			if (dateFormat) {
				date = dateFormat;
				const dateParts = formatter.formatToParts(currentDate);
				["year", "day", "month", "weekday"].forEach((datePart) => {
					date = date.replace(
						`{${datePart}}`,
						(
							dateParts.find((part) => part.type === datePart)?.value || ""
						).replace(/^0+/, "")
					);
				});
			}
			return date;
		}
	} catch (error) {
		console.error(error);
		return getCurrentDateInSelectedLocaleFallback(
			currentDate,
			dateStyle,
			locale,
			options
		);
	}
};

export const getCurrentDateInSelectedLocaleFallback = (
	currentDate,
	dateStyle,
	locale,
	options
) => {
	const isISO = dateStyle === "ISO";
	const date = currentDate.toLocaleDateString(locale, options);
	if (isISO) {
		const [month, day, year] = date.split("/");
		return `${year}-${month}-${day}`;
	} else {
		return date;
	}
};

export const addInitialZero = (time) => {
	return (time < 10 ? "0" : "") + time;
};

export const formatDateTime = (date) => {
	try {
		let hours = date.getHours();
		const ampm = hours >= 12 ? "PM" : "AM";
		const month = addInitialZero(date.getMonth() + 1);
		const day = addInitialZero(date.getDate());
		const minutes = addInitialZero(date.getMinutes());
		const seconds = addInitialZero(date.getSeconds());
		hours = hours % 12;
		hours = hours ? hours : 12;
		hours = addInitialZero(hours);

		return `${month}/${day}/${date.getFullYear()} ${hours}:${minutes}:${seconds}${ampm}`;
	} catch {
		return "";
	}
};
export const isDateWithinRange = (selectedDateStr, maxEnabledDays = 0) => {
	try {
		const selectedDate = new Date(selectedDateStr);
		const limitDate = new Date();
		limitDate.setDate(limitDate.getDate() + Number(maxEnabledDays));
		if (selectedDate > limitDate) {
			return false;
		}
		return true;
	} catch (error) {
		return false;
	}
};
